// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VEq8","toggle":"styles_toggle__1PLjW","preview":"styles_preview__34usR"};